<template>
    <div></div>
</template>

<script>
import BelowHelpBlock from './BelowHelpBlock.js';
export default BelowHelpBlock;
</script>
